$.extend(true, BT, {
	sendRecommendationTrekkieEvent: function(grid) {
    if (
      !window.ShopifyAnalytics ||
      !window.ShopifyAnalytics.lib ||
      !window.ShopifyAnalytics.lib.track
    ) {
      return;
    }

    var numberOfRecommendationsDisplayed = grid.find(
      '.grid__item'
    ).length;

    window.ShopifyAnalytics.lib.track('Product Recommendations Displayed', {
      theme: Shopify.theme.name,
      didPageJumpOccur: true,
      numberOfRecommendationsDisplayed: numberOfRecommendationsDisplayed
    });
  },

  loadRecommendationProduct: function(ele) {
    var ins = this;
    if(ele.length > 0) {
      var productId = ele.attr('data-product-id');
      var view = ele.data('view');
      if(!ele.hasClass('loaded')) {
        ins.callAjax(ele.attr('data-url'), 'GET', {}, null, function(sectionHtml) {
          var html = $('.freb__inner-js', sectionHtml).html();
          var grid;
          if(view == 'slider') {
            grid = ele.children('.cross-sell-list');
            grid.html(html);
            grid.addClass(ins.selectors.slider.useTouchMobile + ' ' + ins.selectors.slider.default.replace('.',''));
            ins.initSlider(ele, false, false);
            ins.initDealCountdown(grid);
          } else {
            grid = ele.parents('.freb__inner-js').first();
            grid.append(html);
          }
          ins.sendRecommendationTrekkieEvent(grid); 
          ins.convertCurrencySilence(grid.find('span.money'));
          ins.applyCustomColorSwatches(grid);
          ins.reLoadReview(grid);
          BTFreBought.init();
          ele.parent().find('.loading-not-full').remove();
        }, function() {
          ele.hide();
        })
      } else {
        var grid;
        if(view == 'slider') {
          grid = ele.children('.cross-sell-list');
          grid.addClass(ins.selectors.slider.useTouchMobile + ' ' + ins.selectors.slider.default.replace('.',''));
          ins.initSlider(ele, false, false);
          ins.initDealCountdown(grid);
          ins.popularAddedWishlistItems(grid);
        } else {
          grid = ele.parents('.freb__inner').first();
          BTFreBought.init(); 
        }
        ins.applyCustomColorSwatches(grid);
      }
    }
  }
});

theme.productCrosssell = {};
theme.ProductCrosssellSection = (function() {
  function ProductCrosssellSection(container) {
    var $container = this.$container = $(container);
		var crosssellEle = $container.find('.load-crossell');
		if(crosssellEle.length > 0) {
	    BT.loadRecommendationProduct(crosssellEle);
	  } else if($('.freb__inner').length > 0) {
	    BTFreBought.init(); 
	  }
  }

  return ProductCrosssellSection;
})();

theme.sections.constructors['product-crosssell'] = theme.ProductCrosssellSection;